/*! functions.js | Adminuiux 2023-2024 */
"use strict";

import $ from 'jquery';
window.jQuery = $;
window.$ = $;

const daterangepickerLocale = () => {
    if (typeof window.getDaterangepickerLocale === 'function') {
        return window.getDaterangepickerLocale();
    }
    return { format: 'DD/MM/YYYY' };
};

const defaultPickerDate = () => {
    if (window.moment && typeof window.moment === 'function') {
        return window.moment();
    }
    return new Date();
};

var body = $('body');
const desktopSidebarBreakpoint = 992;

/* default window width */
var windowswidth = $(window).width();
$(window).on('resize', function () {
    windowswidth = $(window).width();
});

//Pageloader hide
function PageLoaderHide() {
    $('.pageloader').fadeOut();
    body.removeClass('overflow-hidden');
}
window.PageLoaderHide = PageLoaderHide;

// fixed header content space
function fixedHeaderSpace() {
    if ($('.adminuiux-header .navbar').hasClass('fixed-top') === true) {
        $('.adminuiux-sidebar').css('padding-top', $('.adminuiux-header .navbar').outerHeight());
        $('.adminuiux-content').css('padding-top', $('.adminuiux-header .navbar').outerHeight());
    }
}
window.fixedHeaderSpace = fixedHeaderSpace;

function fixedFooterSpace() {
    $(".adminuiux-mobile-footer").length > 0 && $("body").css("padding-bottom", $(".adminuiux-mobile-footer").outerHeight())
}
window.fixedFooterSpace = fixedFooterSpace;

function activeHeader() {
    if ($(window).scrollTop() > 30) {
        $('.adminuiux-header').addClass('active');
    } else {
        $('.adminuiux-header').removeClass('active');
    }
}
window.activeHeader = activeHeader;

// scrolling direction 

let lastScrollTop = document.documentElement.scrollTop || 0;
function scrolldirection(currentScrollTop) {
    var st = typeof currentScrollTop === 'number' ? currentScrollTop : document.documentElement.scrollTop;
    if (st > lastScrollTop) {
        body.addClass('scrolldown');
        body.removeClass('scrollup');
    } else if (st <= lastScrollTop) {
        body.addClass('scrollup');
        body.removeClass('scrolldown');
    }
    lastScrollTop = st;
}
window.scrolldirection = scrolldirection;

// search open close
function openSearch() {
    $('.adminuiux-search-full').addClass('active')
}
window.openSearch = openSearch;

function closeSearch() {
    $('.adminuiux-search-full').removeClass('active');
}
window.closeSearch = closeSearch;

function contentClick() {
    if ($('.adminuiux-search-full').hasClass('active') === true) {
        $('.adminuiux-search-full').removeClass('active');
    }
    if ($('body').hasClass('sidebar-open') === true) {
        $('body').removeClass('sidebar-open');
    }
}
window.contentClick = contentClick;

//Set Active Links
function setActivelink() {
    var url = window.location.href;
    var activePage = url;
    $('#header-navbar .navbar-nav .nav-item .nav-link').each(function () {
        var linkPage = this.href;
        if (activePage == linkPage) {
            $(this).addClass("active").attr('aria-current', 'page');
        }
    });


    $(".adminuiux-sidebar .adminuiux-sidebar-inner .nav .nav-item .nav-link").each(function () {
        if ($(this).closest('[data-route-active-managed="server"]').length > 0) {
            return;
        }

        var linkPage = this.href;

        if (activePage == linkPage) {
            $(this).addClass("active");
            $(this).closest('.dropdown').find('.dropdown-menu').addClass('show');
            $(this).closest('.dropdown').find('.dropdown-toggle').addClass('show');
        }
    });
    $(".adminuiux-mobile-footer .nav .nav-item .nav-link").each(function () {
        var linkPage = this.href;
        if (activePage == linkPage) {
            $(this).addClass("active").attr('aria-current', 'page');
        }
    })
}
window.setActivelink = setActivelink;

function persistSidebarPreference(iconOnly) {
    const stateUrl = body.attr('data-sidebar-state-url');
    if (!stateUrl) {
        return;
    }
    const payload = new URLSearchParams();
    payload.append('icon_only', iconOnly ? '1' : '0');
    fetch(stateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: payload.toString(),
    }).catch(function () {
        // keep UI responsive even if persistence request fails
    });
}

function setSidebarMenuLabels() {
    $('.adminuiux-sidebar .nav .nav-item > .nav-link').each(function () {
        const link = $(this);
        const label = $.trim(link.find('.menu-name').first().text());
        if (label !== '') {
            link.attr('data-menu-label', label);
        }
    });
}

let sidebarTogglerCaptureBound = false;
function bindSidebarTogglerCapture() {
    if (sidebarTogglerCaptureBound || typeof document === 'undefined') {
        return;
    }
    sidebarTogglerCaptureBound = true;

    document.addEventListener('click', function (event) {
        const target = event.target;
        if (!target || typeof target.closest !== 'function') {
            return;
        }
        const toggler = target.closest('[data-sidebar-toggle], .sidebar-toggler');
        if (!toggler) {
            return;
        }

        // Prevent legacy inline/third-party handlers from forcing full sidebar hide.
        event.preventDefault();
        if (typeof event.stopImmediatePropagation === 'function') {
            event.stopImmediatePropagation();
        } else {
            event.stopPropagation();
        }
        initSidebar();
    }, true);
}

function applySidebarIconOnlyState(iconOnly) {
    body.attr('data-sidebar-icon-only', iconOnly ? '1' : '0');
    if (windowswidth >= desktopSidebarBreakpoint) {
        body.removeClass('sidebar-open sidebar-close');
        body.toggleClass('sidebar-icon-only', !!iconOnly);
        return;
    }
    body.removeClass('sidebar-icon-only');
}

function initSidebarState() {
    setSidebarMenuLabels();
    bindSidebarTogglerCapture();
    const initialIconOnly = body.attr('data-sidebar-icon-only') === '1';
    applySidebarIconOnlyState(initialIconOnly);
}
window.initSidebarState = initSidebarState;

function syncSidebarModeOnResize() {
    const desiredIconOnly = body.attr('data-sidebar-icon-only') === '1';
    if (windowswidth >= desktopSidebarBreakpoint) {
        body.removeClass('sidebar-open sidebar-close');
        body.toggleClass('sidebar-icon-only', desiredIconOnly);
        return;
    }
    body.removeClass('sidebar-icon-only');
}
window.syncSidebarModeOnResize = syncSidebarModeOnResize;

//Sidebar
function initSidebar() {
    //Open/Close sidebar    
    if (windowswidth >= desktopSidebarBreakpoint) {
        const nextIconOnly = !(body.attr('data-sidebar-icon-only') === '1');
        applySidebarIconOnlyState(nextIconOnly);
        persistSidebarPreference(nextIconOnly);
    } else {
        body.toggleClass('sidebar-open');
    }
}
window.initSidebar = initSidebar;

// image cover ion background set
function coverimg() {
    $('.coverimg').each(function () {
        $(this).css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
        $(this).find('img').hide()
    })
}
window.coverimg = coverimg;

// drop down menu click dont close 
function dontclosedd() {
    $('.dropdown-dontclose').on('click blur', function (event) {
        $('.dropdown-item').removeClass('show').next('.dropdown-menu').removeClass('show');
        event.stopPropagation();
        $(this).find('.dropdown-item').addClass('show').next().addClass('show');
    });
}
window.dontclosedd = dontclosedd;

// copy code 
$('.copycode').on('click', function () {
    var thisEl = $(this);
    var text = thisEl.addClass('active').prev().find('code').text();
    var elem = document.createElement("textarea");
    document.body.appendChild(elem);
    elem.value = text;
    elem.select();
    document.execCommand('copy');
    document.body.removeChild(elem);
    setTimeout(function () {
        thisEl.removeClass('active')
    }, 500)
});

//Scroll to top
function scrollToTop() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
}
window.scrollToTop = scrollToTop;

/* auto select mode */
function autoThemeMode() {
    const runColorMode = (fn) => {
        if (!window.matchMedia) {
            return;
        }
        const query = window.matchMedia('(prefers-color-scheme: dark)');
        fn(query.matches);
        query.addEventListener('change', (event) => fn(event.matches));
    }
    runColorMode((isDarkMode) => {
        if (isDarkMode) {
            document.documentElement.setAttribute("data-bs-theme", "dark");
        } else {
            document.documentElement.setAttribute("data-bs-theme", "light");
        }
    })
}
window.autoThemeMode = autoThemeMode;

//Go back in history
function goBack() {
    window.history.go(-1);
}
window.goBack = goBack;

//Back to top
let backToTopBound = false;
function updateBackToTop(currentScrollTop) {
    var pxShow = 300;
    var st = typeof currentScrollTop === 'number' ? currentScrollTop : $(window).scrollTop();
    if (st >= pxShow) {
        $("#backtotop").removeClass('d-none');
    } else {
        $("#backtotop").addClass('d-none');
    }
}
window.updateBackToTop = updateBackToTop;

function initBackToTop() {
    if (backToTopBound) {
        return;
    }
    const btn = $('#backtotop');
    if (!btn.length) {
        return;
    }
    backToTopBound = true;
    btn.on('click', function () {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    });
    updateBackToTop();
}
window.initBackToTop = initBackToTop;

//Customize Datatable
function customizeDatatable() {
}
window.customizeDatatable = customizeDatatable;

// feather icons 
function featherjs() {
    feather.replace();
}
window.featherjs = featherjs;

// bootstrap tooltips 
function bstooltip() {
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}
window.bstooltip = bstooltip;

// swiper auto play no nav
function swipernav() {
    if ($('.swipernav').length > 0) {
        const swiper = new Swiper('.swipernav', {
            slidesPerView: "auto",
            spaceBetween: 16,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },

        });
    }
}
window.swipernav = swipernav;

// swiper auto play nav
function swipernavpagination() {
    if ($('.swipernavpagination').length > 0) {
        const swiper2 = new Swiper('.swipernavpagination', {
            slidesPerView: "auto",
            spaceBetween: 16,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        });
    }
}
window.swipernavpagination = swipernavpagination;

// dropzone 
function mydropzone() {
    if ($('.dropzone').length > 0) {
        window.Dropzone;
    }
}
window.mydropzone = mydropzone;

// Lightweight project rich text editor (legacy function name kept for compatibility).
function summernoteEditor() {
    if (typeof window.initRichTextEditors === 'function') {
        window.initRichTextEditors();
    }
}
window.summernoteEditor = summernoteEditor;

/* date picker calendar */
function datepicker() {
    const input = $('#datepicker');
    if (input.length === 0 || input.data('daterangepicker')) {
        return;
    }

    input.daterangepicker({
        "singleDatePicker": true,
        "minYear": 2023,
        "autoApply": true,
        "linkedCalendars": false,
        "alwaysShowCalendars": true,
        "startDate": defaultPickerDate(),
        "endDate": defaultPickerDate(),
        "opens": "center",
        "buttonClasses": "btn",
        "drops": "up",
        "locale": daterangepickerLocale(),
        "applyButtonClasses": "btn-theme",
        "cancelClass": "btn-light"
    }, function (start, end, label) {
        //console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
    });
}
window.datepicker = datepicker;

/* inline calendar */
function inlinedatepicker() {
    const input = $('#inlinewrap1');
    if (input.length === 0) {
        return;
    }

    if (!input.data('daterangepicker')) {
        input.daterangepicker({
            "singleDatePicker": true,
            "minYear": 2023,
            "autoApply": true,
            "linkedCalendars": false,
            "alwaysShowCalendars": true,
            "parentEl": ".inlinewrap1",
            "startDate": defaultPickerDate(),
            "endDate": defaultPickerDate(),
            "opens": "center",
            "buttonClasses": "btn",
            "drops": "up",
            "locale": daterangepickerLocale(),
            "applyButtonClasses": "btn-theme",
            "cancelClass": "btn-light"
        }, function (start, end, label) {
            //console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
        });
    }

    /* inline calendar activate  */
    input.click();
}
window.inlinedatepicker = inlinedatepicker;

// date range picker
function daterange() {
    const input = $('#daterangepicker');
    if (input.length === 0 || input.data('daterangepicker')) {
        return;
    }

    input.daterangepicker({
        "minYear": 2023,
        "autoApply": true,
        "linkedCalendars": false,
        "alwaysShowCalendars": true,
        "startDate": defaultPickerDate(),
        "endDate": defaultPickerDate(),
        "opens": "center",
        "buttonClasses": "btn",
        "drops": "down",
        "locale": daterangepickerLocale(),
        "applyButtonClasses": "btn-theme",
        "cancelClass": "btn-light"
    }, function (start, end, label) {
        //console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
    });
}
window.daterange = daterange;

// date range picker with predefined range
function daterangeranges() {
    const input = $('#daterangepickerranges');
    if (input.length === 0 || input.data('daterangepicker')) {
        return;
    }

    input.daterangepicker({
        "minYear": 2023,
        "autoApply": false,
        "linkedCalendars": false,
        "alwaysShowCalendars": true,
        "startDate": defaultPickerDate(),
        "endDate": defaultPickerDate(),
        "opens": "center",
        "buttonClasses": "btn",
        "drops": "down",
        "locale": daterangepickerLocale(),
        "applyButtonClasses": "btn-theme",
        "cancelClass": "btn-light",
        "ranges": {
            'Сегодня': [moment(), moment()],
            'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Последние 7 дней': [moment().subtract(6, 'days'), moment()],
            'Последние 30 дней': [moment().subtract(29, 'days'), moment()],
            'Этот месяц': [moment().startOf('month'), moment().endOf('month')],
            'Прошлый месяц': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        },
    }, function (start, end, label) {
        //console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
    });
}
window.daterangeranges = daterangeranges;

const dataTableRuLocale = {
    processing: "\u041F\u043E\u0434\u043E\u0436\u0434\u0438\u0442\u0435...",
    search: "\u041F\u043E\u0438\u0441\u043A:",
    lengthMenu: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C _MENU_ \u0437\u0430\u043F\u0438\u0441\u0435\u0439",
    info: "\u0417\u0430\u043F\u0438\u0441\u0438 \u0441 _START_ \u0434\u043E _END_ \u0438\u0437 _TOTAL_",
    infoEmpty: "\u0417\u0430\u043F\u0438\u0441\u0438 \u0441 0 \u0434\u043E 0 \u0438\u0437 0",
    infoFiltered: "(\u043E\u0442\u0444\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u043D\u043E \u0438\u0437 _MAX_ \u0437\u0430\u043F\u0438\u0441\u0435\u0439)",
    infoPostFix: "",
    loadingRecords: "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430...",
    zeroRecords: "\u0417\u0430\u043F\u0438\u0441\u0438 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442.",
    emptyTable: "\u0412 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u0435",
    paginate: {
        first: "\u041F\u0435\u0440\u0432\u0430\u044F",
        previous: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0430\u044F",
        next: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F",
        last: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F",
    },
    aria: {
        sortAscending: ": \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u0441\u0442\u043E\u043B\u0431\u0446\u0430 \u043F\u043E \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0430\u043D\u0438\u044E",
        sortDescending: ": \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043B\u044F \u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0438 \u0441\u0442\u043E\u043B\u0431\u0446\u0430 \u043F\u043E \u0443\u0431\u044B\u0432\u0430\u043D\u0438\u044E",
    },
};

function applyDataTablesLocale() {
    if (!$.fn || !$.fn.dataTable || !$.fn.dataTable.defaults) {
        return;
    }
    $.extend(true, $.fn.dataTable.defaults, { language: dataTableRuLocale });
}
window.applyDataTablesLocale = applyDataTablesLocale;

//dataTable global
function dataTables() {
    /* Initialize dataTable */
    if (!$.fn || typeof $.fn.DataTable !== 'function') {
        return;
    }
    if ($('#dataTable').length > 0) {
        $('#dataTable').DataTable({
            searching: false,
            lengthChange: false,
            autoWidth: false,
            columnDefs: [{ orderable: false, targets: 4 }],
            order: [[0, 'desc']],
            pageLength: 6,
            responsive: true,
        });
        $('#dataTable tr').find('td:visible:last').addClass('lastvisible');
    }

}
window.dataTables = dataTables;

function adjustDataTable() {
    if (!$.fn || !$.fn.dataTable) {
        return;
    }
    var tableEl = $('#dataTable');
    if (!tableEl.length || !$.fn.dataTable.isDataTable(tableEl)) {
        return;
    }
    var table = tableEl.DataTable();
    table.columns.adjust().draw();
    lastvisibletd();
}
window.adjustDataTable = adjustDataTable;

/* responsive last visible table cell after cell hides*/
function lastvisibletd() {
    $('.table tbody tr td').removeClass('lastvisible');
    $('.table tbody tr').each(function () {
        var thisis = $(this);
        thisis.find('td:visible:last').addClass('lastvisible');
    })
}
window.lastvisibletd = lastvisibletd;

/* pasword strength checker */
function checkStrength(password, fieldpasswrap) {
    var strength = 0;

    if (password.length < 6 || password.length < 1) {
        $('#checksterngthdisplay').removeClass().addClass('short check-strength');
        $('#textpassword').removeClass().addClass('text-secondary small');
        return 'Слишком короткий'
    }
    if (password.length > 7) strength += 1
    // If password contains both lower and uppercase characters, increase strength value.  
    if (password.match(/([a-z].*[A-Z])|([A-Z].*[a-z])/)) strength += 1
    // If it has numbers and characters, increase strength value.  
    if (password.match(/([a-zA-Z])/) && password.match(/([0-9])/)) strength += 1
    // If it has one special character, increase strength value.  
    if (password.match(/([!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1
    // If it has two special characters, increase strength value.  
    if (password.match(/(.*[!,%,&,@,#,$,^,*,?,_,~].*[!,%,&,@,#,$,^,*,?,_,~])/)) strength += 1
    // Calculated strength value, we can return messages  
    // If value is less than 2  
    if (strength < 2) {
        $('#checksterngthdisplay').removeClass().addClass('weak check-strength');
        $('#textpassword').removeClass().addClass('text-danger small');
        fieldpasswrap.removeClass('is-valid');
        return 'Слабый пароль';
    } else if (strength == 2) {
        $('#checksterngthdisplay').removeClass().addClass('good check-strength');
        $('#textpassword').removeClass().addClass('text-warning small');
        fieldpasswrap.removeClass('is-valid');
        return 'Нормальный пароль';
    } else {
        $('#checksterngthdisplay').removeClass().addClass('strong check-strength');
        $('#textpassword').removeClass().addClass('text-success small');
        fieldpasswrap.addClass('is-valid');
        return 'Отличный пароль';
    }
}
window.checkStrength = checkStrength;

/* passsword strength checker */
function checkstrength() {
    if ($('#checkstrength').length > 0) {
        $('#checkstrength').on('keyup', function () {

            var fieldpass = $(this);
            var fieldpasswrap = $(this).closest('.check-valid');
            checkStrength(fieldpass.val(), fieldpasswrap);

            if (this.value != '') {
                $('#textpassword').html(checkStrength(fieldpass.val(), fieldpasswrap))
                fieldpass.closest('.check-valid').next('.invalid-feedback').hide();
                // $(this).closest('.check-valid').addClass('is-valid');
            } else {
                fieldpasswrap.removeClass('is-valid').next('.invalid-feedback').show().text("Введите корректное значение")
                $('#checksterngthdisplay').removeClass();
            }
        });
    }
}
window.checkstrength = checkstrength;

/* inner sidebar close */
function innersidebar() {
    $('body').toggleClass('innermenu-close');
}
window.innersidebar = innersidebar;

/* header h padding top*/
function headerpaddingTop() {
    if ($('.header-pt').length > 0) {
        $('.header-pt').css('top', $('header.adminuiux-header > .navbar').outerHeight())
    }
}
window.headerpaddingTop = headerpaddingTop;

/* bootstrap popover  */
function bspopover() {
    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
}
window.bspopover = bspopover;

/* bootstrap toast message */
function bstoast() {
    const toastElList = document.querySelectorAll('.toast')
    const toastList = [...toastElList].map(toastEl => new bootstrap.Toast(toastEl))
}
window.bstoast = bstoast;

/* Range Customize */
function range2() {
    const rangeEle = document.querySelector("#range2")
    const rangeValue = document.querySelector(".value2")

    rangeEle.addEventListener("input", (event) => {
        const temprangeValue = event.target.value;
        rangeValue.textContent = temprangeValue;

        const progress = (temprangeValue / rangeEle.max) * 100;

        rangeEle.style.background = `linear-gradient(to right, var(--adminuiux-theme-1) ${progress}%, var(--adminuiux-bg-1) ${progress}%)`;
    })
}
window.range2 = range2;

// 2
function range3() {
    const rangeEle3 = document.querySelector("#range3")
    const rangeValue3 = document.querySelector(".value3")

    rangeEle3.addEventListener("input", (event) => {
        const temprangeValue = Number(event.target.value);

        rangeValue3.textContent = temprangeValue;

        const progress = (temprangeValue / rangeEle3.max) * 100;

        rangeEle3.style.background = `linear-gradient(to right, var(--adminuiux-theme-1) ${progress}%, var(--adminuiux-bg-1) ${progress}%)`;

        rangeEle3.style.setProperty("--thumb-rotate", `${(temprangeValue / 100) * 2160}deg`)
    })
}
window.range3 = range3;

// 2
function range4() {
    const rangeEle4 = document.querySelector("#range4")
    const rangeValue4 = document.querySelector(".value4")

    rangeEle4.addEventListener("input", (event) => {
        const temprangeValue = event.target.value;
        rangeValue4.textContent = temprangeValue;

        const progress = (temprangeValue / rangeEle4.max) * 100;

        rangeEle4.style.background = `linear-gradient(to right, var(--adminuiux-theme-1) ${progress}%, var(--adminuiux-bg-1) ${progress}%)`;
    })
}
window.range4 = range4;

if ($('.rangevalue').length > 0) {
    $('.rangevalue').each(function () {
        var ranges = $(this);
        $('#' + ranges.attr('data-value')).val(ranges.val());
        ranges.on('mousemove', function () {
            $('#' + ranges.attr('data-value')).val(ranges.val());
        })
    })
}
if ($('.rangevalues').length > 0) {
    $('.rangevalues').each(function () {
        var rangesval = $(this);
        var setrangeval = rangesval.attr('id');

        rangesval.on('change', function () {
            $('[data-value="' + setrangeval + '"]').val(rangesval.val())
        })
    })
}

function selectable() {
    if ($('.selectable').length > 0) {
        $('.selectable').on('click', function () {
            if ($(this).hasClass('anyone') === true) {
                $('.selectable').removeClass('active');
                $(this).addClass('active');
            } else {
                $(this).toggleClass('active');
            }
        })
    }
}
window.selectable = selectable;

function isinframe() {
    if (self !== top) {
        body.addClass('adminuiux-in-iframe')
    } else {
        body.removeClass('adminuiux-in-iframe')
    }
}
window.isinframe = isinframe;

export {
    applyDataTablesLocale,
    dataTables,
    swipernav,
    swipernavpagination,
    adjustDataTable,
    scrolldirection,
    updateBackToTop,
};

